import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { ConsolidationSummaryType } from '@/features/dashboard/types';

async function getTermometroFinanceiroDetalhes(id): Promise<ConsolidationSummaryType> {
  const api = await getApi();
  const { data } = await api.get<ConsolidationSummaryType>(`/termometro/financeiro/detalhes_aluno/?student_id=${id}`, {});
  return data;
}

type QueryFnType = typeof getTermometroFinanceiroDetalhes;

function useTermometroFinanceiroDetalhes(id) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['termometro-financeiro-detalhes', id],
    queryFn: () => getTermometroFinanceiroDetalhes(id),
  });
}

export { getTermometroFinanceiroDetalhes, useTermometroFinanceiroDetalhes };
